module.exports = __webpack_public_path__ + "img/banner.1ae3095c.jpg";